import { TGetOffersResponse } from 'lendingApi/lapiOverrides.types';

export const getProbabilityPill = (
  offer: TGetOffersResponse['data']['offers'][number],
) => {
  const PROBABILITY_PILLS = {
    low_probability_of_offer: {
      label: 'Low chance of approval',
      variant: 'red',
    },
    medium_probability_of_offer: {
      label: 'Medium chance of approval',
      variant: 'yellow',
    },
    high_probability_of_offer: {
      label: 'High chance of approval',
      variant: 'green',
    },
  } as const;

  return offer.probability_of_offer
    ? PROBABILITY_PILLS[offer.probability_of_offer]
    : null;
};
